import { render, staticRenderFns } from "./CommentManage.vue?vue&type=template&id=3937cff6&scoped=true&"
import script from "./CommentManage.vue?vue&type=script&lang=js&"
export * from "./CommentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937cff6",
  null
  
)

export default component.exports